import React, { useState, useEffect, Suspense, lazy } from "react";
import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import VideoBackground from "./components/VideoBackground";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row} from "react-bootstrap";
import Terrain from "./components/terrain";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";

// Lazy load components
const VP = lazy(() => import("./components/Popup/VictoriaPeak"));
const TMS = lazy(() => import("./components/Popup/TaiMoShan"));
const PSL = lazy(() => import("./components/Popup/PatSinLeng"));
const MOS = lazy(() => import("./components/Popup/MaOnShan"));
const LT = lazy(() => import("./components/Popup/LamTsuen"));
const LR = lazy(() => import("./components/Popup/LionRock"));
const Dashboard = lazy(() => import("./components/Home/Dashboard"));
const About = lazy(() => import("./components/About/About"));
const Schedule = lazy(() => import("./components/Schedule"));
const TandC = lazy(() => import("./components/TandC"));
const PeakHour = lazy(() => import("./components/Popup/PeakHour"));
const NonPeakHour = lazy(() => import("./components/Popup/NonPeakHour"));
const Test = lazy(() => import("./components/Home/Dashboard3"));

function App({  }) {
  // const parsed = queryString.parse(window.location.search);
  // console.log(parsed);
  const [load, upadateLoad] = useState(true);

  useEffect(() => 
    {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
    }, []);

    const [selectedLanguage, setSelectedLanguage] = useState(null);
    const [isLanguageSelected,setIsLanguageSelected] = useState(false);
  
    useEffect(() => {
      if (selectedLanguage === 'zh' ) {// Update the page language based on the selected language
        setIsLanguageSelected(true);
      }else if (selectedLanguage === 'en' ) {// Update the page language based on the selected language
        setIsLanguageSelected(true);
      }
      // return () =>{};
    }, [isLanguageSelected]);
  
    const handleLanguageChange = (language) => {
      setSelectedLanguage(language);
      setIsLanguageSelected(true);
    };
    

  return (
    <Router >
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <VideoBackground />
        <main className={`portrait-container ${isLanguageSelected ? 'language-selected' : ''}`} role="main">
          {isLanguageSelected ? <Navbar load={load} language={selectedLanguage}/> : null}
          <ScrollToTop />
          {isLanguageSelected || load ? null : (
            <Container fluid className="p-0">
              <section className="terrain-background" aria-label="Language Selection">
                <div className="terrain" aria-hidden="true">
                  <Terrain />
                </div>
                <nav className="quote-lan" role="navigation" aria-label="Language Navigation">
                  <button 
                    className="lan" 
                    onClick={() => handleLanguageChange("zh")} 
                    aria-label="Switch to Chinese"
                  >
                    中文
                  </button>
                  <div className="divider" aria-hidden="true">|</div>
                  <button 
                    className="lan" 
                    onClick={() => handleLanguageChange("en")} 
                    aria-label="Switch to English"
                  >
                    ENGLISH
                  </button>
                </nav>
                <header className="lan-header">
                  <h1>CKC ll<br/>MEDIA WALL</h1>
                </header>
              </section>
            </Container>
          )}
          <Preloader load={load} />
          <Suspense fallback={
            <div className="loading-spinner" role="alert" aria-busy="true" aria-label="Loading content">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          }>
            <Routes>
              {isLanguageSelected ? (
                <>
                  <Route path="/LT" element={<LT language={selectedLanguage}/>} />
                  <Route path="/MOS" element={<MOS language={selectedLanguage}/>} />
                  <Route path="/PSL" element={<PSL language={selectedLanguage}/>} />
                  <Route path="/VP" element={<VP language={selectedLanguage}/>} />
                  <Route path="/TMS" element={<TMS language={selectedLanguage}/>} />
                  <Route path="/LR" element={<LR language={selectedLanguage}/>} />
                  <Route path="/" element={<Dashboard language={selectedLanguage}/>} />
                  <Route path="/Schedule" element={<Schedule language={selectedLanguage}/>} />
                  <Route path="/about" element={<About language={selectedLanguage}/>} />
                  <Route path="/TandC" element={<TandC language={selectedLanguage}/>} />
                  <Route path="/Peak" element={<PeakHour language={selectedLanguage}/>} />
                  <Route path="/NPeak" element={<NonPeakHour language={selectedLanguage}/>} />
                </>
              ) : null}
              <Route path="/Dtest" element={<Test language={selectedLanguage}/>} />
              <Route path="*" element={<Navigate to="/"/>} />
            </Routes>
          </Suspense>
          {isLanguageSelected ? <Footer language={selectedLanguage} /> : null}
        </main>
      </div>
    </Router>
  );
}

export default App;
